// @flow

import React from 'react';
import { marked } from 'marked';
import { Link } from 'react-router';
import Translate from 'client/components/translate';
import GuideFooter from './guideFooter';

/* eslint-disable react/no-danger, react/no-array-index-key */

type Props = {
  sectionHeader: string,
  sectionPage: Object,
  subsectionPage: Object | null,
  healthGuideTranslations: Object,
  trackAction: Function,
};

function unescapeCharacters(body) {
  let fixedResult;

  if (body) {
    fixedResult = body.replace(/&#39;/gi, "'");
    fixedResult = fixedResult.replace(/&quot;/gi, '"');
  }

  return fixedResult;
}

const GuideBody = ({
  sectionHeader,
  sectionPage,
  subsectionPage,
  healthGuideTranslations,
  trackAction,
}: Props) => {
  // Converts Contentful Markdown to HTML
  let markedData = subsectionPage ? marked(subsectionPage.body) : marked(sectionPage.body);
  let subsectionContent;

  // Only fires if current section has subsections, is not a subsection itself,
  // and Contentful content has 'STARTCONTENT' in its body.
  if (sectionPage.pages && !subsectionPage && markedData.split('STARTCONTENT').length > 1) {
    const splitContent = markedData.split('STARTCONTENT');
    // Because splitting misaligns <p> tags, the following methods will add and remove
    // <p> and </p> tags as needed.
    const startContent = `${splitContent[0]}</p>`;
    const contentToModify = splitContent[1].slice(4);
    // Second Contentful split trigger phrase, to assist inserting "Learn More"
    // react-router Link component
    markedData = contentToModify.split('LearnMoreFunctionSplit');

    // Pop removes last element of array, which is just </p>
    markedData.pop();

    const markdownDivs = markedData.map((markdownDiv, idx) => {
      const URL = sectionPage.pages[idx].key;

      const divMarkup = markdownDiv.slice(0, 4) === '</p>' ? markdownDiv.slice(4) : markdownDiv;
      const splitText = divMarkup.split('<p>');

      const header = splitText[0];
      const bodyBeforeEscape = splitText[1];
      const body = unescapeCharacters(bodyBeforeEscape);

      return (
        <div className="marked-div-parent" key={idx}>
          <div dangerouslySetInnerHTML={{ __html: header }} className="marked-div-header" />
          <p className="marked-div-body">
            {body}
            <Link
              to={`/guide/${sectionPage.key}/${URL}`}
              title="Learn More"
              className="embedded-section-link">
              <Translate path="healthGuide.learnMore" />
            </Link>
          </p>
        </div>
      );
    });

    subsectionContent = (
      <div className="subsection-content">
        <div dangerouslySetInnerHTML={{ __html: startContent }} className="start-content" />
        {markdownDivs}
      </div>
    );
  }

  return (
    <div className="guide-body-parent-container">
      <h4 className="section-header">{sectionHeader}</h4>
      {subsectionContent || <div dangerouslySetInnerHTML={{ __html: markedData }} />}
      <GuideFooter healthGuideTranslations={healthGuideTranslations} trackAction={trackAction} />
    </div>
  );
};

export default GuideBody;
